module.exports = __webpack_public_path__ + "img/checkbox_inactive.2ac52558.svg";